import React from 'react';
import withRouter from 'src/config/withRouter';
import { withTranslation } from 'react-i18next';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme=> ({
    mainDiv:{
        width:'calc(100% - 60px)',
        display:'flex',
        flexDirection:'row',
        justifyContent:'space-between',
        alignItems:'center',
        borderRadius:'5px',
        backgroundColor:'#fff',
        padding:'10px 30px',
        marginBottom:'30px',
        boxShadow:'0px 1px 2px #00000038',
        [theme.breakpoints.between('xs','md')]: {
            width:'calc(100% - 20px)',
            padding:'10px 10px',
        }
    },

    avatarDiv:props=>({
        width:'71px',
        height:'71px',
        borderRadius:'50%',
        cursor:'pointer',
        backgroundColor: props.backgroundColor ? props.backgroundColor : '#0F467A',
        [theme.breakpoints.between('xs','md')]: {
            width:'60px',
            height:'60px',
        },
        '& img':{
            width:'100%',
            height:'100%',
            borderRadius:'50%'
        }
    }),

    companyName:props=> ({
        fontSize:'20px',
        color:props.fontDarkColor ? props.fontDarkColor :'#0F467A',
        fontWeight:'bold',
        textTransform:'capitalize',
        textAlign:'center',
        maxWidth: '90%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        cursor:'pointer',
        [theme.breakpoints.between('xs','md')]: {
            fontSize:'13px',
        }
    }),

    compType:{
        color:'#000000',
        fontSize:'15px',
        textAlign:'center',
        textTransform:'capitalize',
        paddingBottom: '10px',
        marginTop:'-8px',
        [theme.breakpoints.between('xs','md')]: {
            fontSize:'12px',
        }
    },

    marRight:{
        marginRight:'10px',
    },
    marLeft:{
        marginLeft:'10px',
    },

    leftSection:{
        display:'flex',
        flexDirection:'row',
        width:'80%',
        alignItems:'center'
    },

    nameDiv:{
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-start',
        width:'calc(100% - 81px)',
        [theme.breakpoints.between('xs','md')]: {
            width:'calc(100% - 60px)'
        }
    },

    selectBox:{
        padding: '10px',
        borderRadius: '6px',
        borderColor: 'rgba(0, 0, 0, 0.11)',
        width: '30%',
        textTransform:'capitalize'
    }
}));

function CategoryCompInfo(props) {

    const { i18n,backgroundColor, fontDarkColor,companyName,categories,onChangeCat,categoryId, avatar, companyType, redirectEvent } = props;
    const classes = useStyles({backgroundColor,fontDarkColor});
    const isRTL = i18n.translator.language;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;

    const _onChange = e => {
        const value = e.target.value;
        onChangeCat(value);
    }


    return(
        <div className={classes.mainDiv}>
            <div className={classes.leftSection}>
                <div className={classes.avatarDiv} onClick={redirectEvent}>
                    <ImgLazyLoad>
                        <img src={avatar ? avatar : ''} alt='company' />
                    </ImgLazyLoad>
                </div>
                <div className={`${classes.nameDiv} ${isRTL === 'ar' ? classes.marRight : classes.marLeft}`}>
                    <span className={classes.companyName} style={{fontFamily:"'Cairo', sans-serif"}} onClick={redirectEvent}>{companyName ? companyName : '---'}</span>
                    <span className={classes.compType} style={{fontFamily}}>{companyType ? companyType : '---'}</span>
                </div>
            </div>

            <select className={classes.selectBox} onChange={_onChange} value={categoryId}>
                {React.Children.toArray(categories.map(v=> <option value={v.id}>{v.name}</option>))}
            </select>
        </div>
    )
}

export default withRouter(withTranslation('common')(CategoryCompInfo));